import React, { Component } from 'react'
import { connect } from 'react-redux'
import starIcon from '../../icons/star.svg';
import starIconFilled from '../../icons/star_filled.svg';
import ReactHtmlParser from 'react-html-parser'; 


class ReviewSummary extends Component { 

  constructor(props) {
    super(props);
    this.state = {
    review:'',
    oneStar:false,
    twoStar:false,
    threeStar:false,
    fourStar:false,
    fiveStar:false,
    reviewScore:0,
    name:''
    }
    }

    componentDidMount(props){
      this.setState({
        oneStar:this.props.project.oneStar,
        twoStar:this.props.project.twoStar,
        threeStar:this.props.project.threeStar,
        fourStar:this.props.project.fourStar,
        fiveStar:this.props.project.fiveStar,
        name:this.props.project.name
      })
    }


  showReview = (e) => {
  e.preventDefault();
    if(document.getElementById('review'+this.props.project.id).style.display==='none' || document.getElementById('review'+this.props.project.id).style.display===''){
      document.getElementById('review'+this.props.project.id).style.display = "block";  
    }
    else{
      document.getElementById('review'+this.props.project.id).style.display = "none"; 
    }
  }

  render(){
    const { project } = this.props;
    const oneStar = this.state.oneStar?starIconFilled:starIcon;
    const twoStar = this.state.twoStar?starIconFilled:starIcon;
    const threeStar = this.state.threeStar?starIconFilled:starIcon;
    const fourStar = this.state.fourStar?starIconFilled:starIcon;
    const fiveStar = this.state.fiveStar?starIconFilled:starIcon;


    return(
      <div className='reviewSummary'>
        <div className='reviewContainer2' onClick={this.showReview}>
          <span> {this.state.name} </span>
          <div className='reviewContainer'>
            <div><img src={oneStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={twoStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={threeStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={fourStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={fiveStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
          </div>
        </div>
        <div className="showReview" style={{"display":"none", "textAlign":"left"}} id={'review'+this.props.project.id}>
         <div> { ReactHtmlParser (project.review) } </div>
        </div>
      </div>
    )
  }

}


const mapStateToProps = (state) => {
  return {
    state
  }
}

export default connect(mapStateToProps)(ReviewSummary)